var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("EXPERIENCE MANAGER")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex m__t--42" }, [
            _c(
              "div",
              {
                staticClass: "tab-experience-manager m__r--35",
                class: {
                  "tab-experience-manager-active": _vm.tabSelected === "single"
                },
                on: {
                  click: function($event) {
                    _vm.selectTab("single")
                  }
                }
              },
              [_vm._v("\n        SINGLE FORM\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-experience-manager",
                class: {
                  "tab-experience-manager-active":
                    _vm.tabSelected === "multiple"
                },
                on: {
                  click: function($event) {
                    _vm.selectTab("multiple")
                  }
                }
              },
              [_vm._v("\n        MULTIPLE FORM\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c(
            "v-server-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.load_first && _vm.tabSelected === "single",
                  expression: "load_first && tabSelected === 'single'"
                }
              ],
              ref: "formUiTableComponent",
              staticClass: "jTable",
              attrs: { columns: _vm.columns, options: _vm.table_options },
              on: { loading: _vm.loading, loaded: _vm.loaded },
              scopedSlots: _vm._u([
                {
                  key: "checkbox",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        staticClass: "jTableReport",
                        staticStyle: { width: "5px" }
                      },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-checkbox-group",
                              {
                                model: {
                                  value: _vm.selected_rows,
                                  callback: function($$v) {
                                    _vm.selected_rows = $$v
                                  },
                                  expression: "selected_rows"
                                }
                              },
                              [
                                _c("b-form-checkbox", {
                                  attrs: { value: props.row }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                },
                {
                  key: "id",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetail(props.row.id)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                    )
                  }
                },
                {
                  key: "name",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetail(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(props.row.name) + "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "type",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetail(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.typeUi(props.row)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "source",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetail(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.sourceUi(props.row)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "created_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetail(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.created_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "updated_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetail(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.updated_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: { click: _vm.openModalCreateNew }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: {
                            click: function($event) {
                              _vm.$refs.appImportModal.show()
                              _vm.dropboxImportShow = true
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-cloud-upload fa-lg" }),
                          _vm._v(" Import\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          attrs: { inline: "" },
                          on: {
                            keypress: function($event) {
                              if (
                                !("button" in $event) &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              _vm.filter(_vm.filter_data)
                            }
                          }
                        },
                        [
                          _c("j-select", {
                            staticClass: "m__r--5",
                            attrs: {
                              options: _vm.options_search,
                              placeholder: "Filter By"
                            },
                            model: {
                              value: _vm.select_type,
                              callback: function($$v) {
                                _vm.select_type = $$v
                              },
                              expression: "select_type"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "filterInputSingle",
                            staticStyle: { width: "250px", height: "35px" },
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data,
                              callback: function($$v) {
                                _vm.filter_data = $$v
                              },
                              expression: "filter_data"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.load_first && _vm.tabSelected === "single"
            ? _c("jLoadingTable")
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-server-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.load_first_multi && _vm.tabSelected === "multiple",
                  expression: "load_first_multi && tabSelected === 'multiple'"
                }
              ],
              ref: "multiFormUiTableComponent",
              staticClass: "jTable",
              attrs: {
                columns: _vm.columns_multi,
                options: _vm.table_options_multi
              },
              on: { loading: _vm.loadingMulti, loaded: _vm.loadedMulti },
              scopedSlots: _vm._u([
                {
                  key: "checkbox",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        staticClass: "jTableReport",
                        staticStyle: { width: "5px" }
                      },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-checkbox-group",
                              {
                                model: {
                                  value: _vm.selected_rows,
                                  callback: function($$v) {
                                    _vm.selected_rows = $$v
                                  },
                                  expression: "selected_rows"
                                }
                              },
                              [
                                _c("b-form-checkbox", {
                                  attrs: { value: props.row }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                },
                {
                  key: "id",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetailMulti(props.row.id)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                    )
                  }
                },
                {
                  key: "name",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetailMulti(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(props.row.name) + "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "type",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetailMulti(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.typeUi(props.row)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "form_data_name",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetailMulti(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(props.row.form_data_name) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "created_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetailMulti(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.created_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                },
                {
                  key: "updated_at",
                  fn: function(props) {
                    return _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.openDetailMulti(props.row.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.convertDateTime(props.row.updated_at)) +
                            "\n      "
                        )
                      ]
                    )
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: { click: _vm.openModalCreateNew }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: {
                            click: function($event) {
                              _vm.$refs.appImportModal.show()
                              _vm.dropboxImportShow = true
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-cloud-upload fa-lg" }),
                          _vm._v(" Import\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          attrs: { inline: "" },
                          on: {
                            keypress: function($event) {
                              if (
                                !("button" in $event) &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              _vm.filterMulti(_vm.filter_data_multi)
                            }
                          }
                        },
                        [
                          _c("j-select", {
                            staticClass: "m__r--5",
                            attrs: {
                              options: _vm.options_search_multi,
                              placeholder: "Filter By"
                            },
                            model: {
                              value: _vm.select_type_multi,
                              callback: function($$v) {
                                _vm.select_type_multi = $$v
                              },
                              expression: "select_type_multi"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "filterInputMultiple",
                            staticStyle: { width: "250px", height: "35px" },
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data_multi,
                              callback: function($$v) {
                                _vm.filter_data_multi = $$v
                              },
                              expression: "filter_data_multi"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.load_first_multi && _vm.tabSelected === "multiple"
            ? _c("jLoadingTable")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "searchFormModal",
          attrs: {
            show: _vm.popoverSearchShow,
            container: "form-search-popover",
            target: "targetSearch",
            triggers: "click",
            placement: "right"
          },
          on: {
            "update:show": function($event) {
              _vm.popoverSearchShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "m__b--10" }, [_vm._v("Search Data")]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              attrs: { inline: "" },
              on: {
                keypress: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  $event.preventDefault()
                  _vm.filter(_vm.filter_data)
                }
              }
            },
            [
              _c("j-select", {
                staticClass: "m__r--5",
                attrs: { disabled: false, options: _vm.options_search },
                model: {
                  value: _vm.select_type,
                  callback: function($$v) {
                    _vm.select_type = $$v
                  },
                  expression: "select_type"
                }
              }),
              _vm._v(" "),
              _c("j-input", {
                staticClass: "m__r--5",
                attrs: { placeholder: "Search" },
                model: {
                  value: _vm.filter_data,
                  callback: function($$v) {
                    _vm.filter_data = $$v
                  },
                  expression: "filter_data"
                }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue outline",
                  staticStyle: { "margin-top": "-19px" },
                  on: {
                    click: function($event) {
                      _vm.filter(_vm.filter_data)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search bold" }),
                  _vm._v(" Search\n      ")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalForm",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.isOpen
            ? _c("j-form-ui-create", {
                attrs: { mode: "single" },
                on: { "close-modal": _vm.closeModalCreate }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "searchFormMultiModal",
          attrs: {
            show: _vm.popoverSearchMultiShow,
            container: "form-search-popover",
            target: "targetSearchMulti",
            triggers: "click",
            placement: "right"
          },
          on: {
            "update:show": function($event) {
              _vm.popoverSearchMultiShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "m__b--10" }, [_vm._v("Search Data")]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              attrs: { inline: "" },
              on: {
                keypress: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  $event.preventDefault()
                  _vm.filterMulti(_vm.filter_data_multi)
                }
              }
            },
            [
              _c("j-select", {
                staticClass: "m__r--5",
                attrs: { disabled: false, options: _vm.options_search_multi },
                model: {
                  value: _vm.select_type_multi,
                  callback: function($$v) {
                    _vm.select_type_multi = $$v
                  },
                  expression: "select_type_multi"
                }
              }),
              _vm._v(" "),
              _c("j-input", {
                staticClass: "m__r--5",
                attrs: { placeholder: "Search" },
                model: {
                  value: _vm.filter_data_multi,
                  callback: function($$v) {
                    _vm.filter_data_multi = $$v
                  },
                  expression: "filter_data_multi"
                }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue outline",
                  staticStyle: { "margin-top": "-19px" },
                  on: {
                    click: function($event) {
                      _vm.filterMulti(_vm.filter_data_multi)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search bold" }),
                  _vm._v(" Search\n      ")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalFormMulti",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.isOpenMulti
            ? _c("j-multiple-form-ui-create", {
                on: { "close-modal": _vm.closeModalCreateMulti }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appTypeFormDataModal",
          staticClass: "mod-form modal-type-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v(
              "CREATE " +
                _vm._s(_vm.tabSelected === "multiple" ? "MULTIPLE" : "SINGLE") +
                " EXPERIENCE MANAGER"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-type-list-options" }, [
            _c(
              "div",
              {
                staticClass: "container-option",
                class: _vm.typeMode === "blank" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.selectMode("blank")
                  }
                }
              },
              [
                _vm.typeMode === "blank"
                  ? _c("img", {
                      attrs: { src: require("@/assets/icon/blank-blue.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/icon/blank.png") }
                    }),
                _vm._v(" "),
                _c("span", { staticClass: "text-option" }, [
                  _vm._v("Create New Blank")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-option",
                class: _vm.typeMode === "code" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.selectMode("code")
                  }
                }
              },
              [
                _vm.typeMode === "code"
                  ? _c("img", {
                      attrs: { src: require("@/assets/icon/code-blue.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/icon/code.png") }
                    }),
                _vm._v(" "),
                _c("span", { staticClass: "text-option" }, [
                  _vm._v("Execute Code")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeTypeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      { staticClass: "btn blue", on: { click: _vm.nextStep } },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeFormDataModal",
          staticClass: "mod-form modal-code-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v(
              "CREATE " +
                _vm._s(_vm.tabSelected === "multiple" ? "MULTIPLE" : "SINGLE") +
                " EXPERIENCE MANAGER"
            )
          ]),
          _vm._v(" "),
          _c("label", [_vm._v(" JSON ")]),
          _vm._v(" "),
          _vm.showEditor
            ? _c("j-monaco-editor", {
                ref: "jsonEditor",
                attrs: { value: _vm.jsonData, language: "json" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCodeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createCodeData }
                      },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-floating-data-manager",
          class: {
            "show-container-floating-data-manager": _vm.showProperties,
            "hide-container-floating-data-manager": !_vm.showProperties,
            "container-floating-data-manager-long": !_vm.is_sidebar_minimized
          }
        },
        [
          _c("div", { staticClass: "count-data-selected" }, [
            _vm._v(_vm._s(_vm.selected_rows.length))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "label-data-selected" }, [
            _vm._v(
              _vm._s(_vm.tabSelected === "single" ? "Single" : "Multiple") +
                " Experience Manager "
            ),
            _c("br"),
            _vm._v(" Selected")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-export-data", on: { click: _vm.exportData } },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon/export-data-white.svg") }
              }),
              _vm._v(" Export\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-data-selected",
              on: {
                click: function($event) {
                  _vm.selected_rows = []
                }
              }
            },
            [_vm._v("X")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appImportModal",
          staticClass: "mod-form modal-add-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("IMPORT")
          ]),
          _vm._v(" "),
          _vm.dropboxImportShow
            ? _c("div", { staticClass: "dropbox-oos" }, [
                _c("input", {
                  staticClass: "input-file",
                  attrs: { type: "file", multiple: "" },
                  on: {
                    change: function($event) {
                      _vm.handleFileUpload($event.target.files)
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("@/assets/form-data/file-dropbox.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label-dropbox" }, [
                  _vm._v("Drop your file here, or "),
                  _c("span", [_vm._v("browse")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "label-support-dropbox" }, [
                  _vm._v("Support : ZIP")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray",
                        on: { click: _vm.closeImportForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5ab4bd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ab4bd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager/jFormUiList.vue
// module id = null
// module chunks = 